module.exports = __webpack_public_path__ + "img/Ido_Golding-500x500.7c1f9854.jpg";